// Customer-facing wording for Order.cancelReason (set when a refund closes the order).
// 'other' / 'admin_mistake' aren't meaningful to the customer, so they keep "Cancel by store".
const CANCEL_REASON_LABELS = {
  cancelled: 'สินค้ายกเลิก',
  not_found: 'หาของไม่เจอ',
  late_order: 'สั่งซื้อไม่ทัน',
  cannot_buy: 'ซื้อไม่ได้',
  damaged: 'สินค้าเสียหาย',
};

// Air/sea-aware display wording for an order's shipStatus (the stored values are sea-worded).
// Presentation only — the stored status is unchanged. Used by the order-summary table, which
// wants the 2nd line on "ระหว่างขนส่งในญี่ปุ่น" (render with white-space: pre-line). The profile
// orders table keeps its own shorter mapping without the 2nd line.
// A cancelled order with a known cancelReason shows that reason instead of "Cancel by store".
export const mapShipStatus = (status, isAir, order = {}) => {
  if (status === 'Cancel by store' && CANCEL_REASON_LABELS[order.cancelReason]) {
    const label = CANCEL_REASON_LABELS[order.cancelReason];
    return order.productPayment === 'คืนเงินแล้ว' ? `${label}\n(คืนเงินแล้ว)` : label;
  }
  if (status === 'ระหว่างขนส่งในญี่ปุ่น') return 'ระหว่างขนส่งในญี่ปุ่น\n(คนขายส่งออกแล้ว)';
  if (status === 'คลังญี่ปุ่น รอขึ้นเรือ') return 'คลังญี่ปุ่น';
  if (status === 'อยู่บนเรือ' && isAir) return 'อยู่ระหว่างส่งกลับไทย';
  return status;
};
